<template lang="pug">
  div
    header-without-menu
    div.content
      div.form-container
        div
          div: img.logo-image(src="../../../assets/LMM-3.0-logo.svg")
          div.mt-3.mb-5(style="font-size: 16px;" v-html="$t('join_description')")
        
        b-form(@submit.prevent='register')
          // 필수 항목
          div.form-section-title.mb-3 {{$t('join_form.required_field')}}
          
          // 이메일 아이디
          div.form-row.align-items-center
            label.form-label.custom-label(for="mgrid")
              | {{$t('Email')}}
              strong.text-danger *
            div.col
              b-form-input#mgrid(
                type="email",
                v-model="form.mgrid",
                :placeholder="$t('Email')",
                :state="validates.mgrid && validates.exist",
                @input="isValidId"
              )
              b-form-invalid-feedback(v-if="!validates.exist") {{$t('id_exist')}}
          
          // 비밀번호
          div.form-row.align-items-center
            label.form-label.custom-label(for="pw")
              | {{$t('PW')}}
              strong.text-danger *
            div.col
              b-form-input#pw(
                :type="showPw ? 'text' : 'password'",
                v-model="form.pw",
                autocomplete="new-password",
                :placeholder="$t('PW_desc')",
                :state="validates.pw",
                @input="isValidPw"
              )
              b-input-group-append(@click='toggleShowPw')
                icon(
                  :name="showPw ? 'eye-slash' : 'eye'",
                  style="position: absolute; right: 2.2rem; top: 50%; transform: translateY(-50%); cursor: pointer;"
                )
          
          // 비밀번호 확인
          div.form-row.align-items-center
            label.form-label.custom-label(for="pwConfirm")
              | {{$t('PW_confirm')}}
              strong.text-danger *
            div.col
              b-form-input#pwConfirm(
                :type="showPw ? 'text' : 'password'",
                v-model="form.pwConfirm",
                autocomplete="new-password",
                :placeholder="$t('PW_confirm_desc')",
                :state="validates.pwConfirm",
                @input="isValidPwConfirm"
              )
          
          // 이름
          div.form-row.align-items-center
            label.form-label.custom-label(for="name")
              | {{$t('name')}}
              strong.text-danger *
            div.col
              b-form-input#name(
                type="text" ,
                v-model="form.name",
                :placeholder="$t('name')",
                :state="validates.name",
                @input="isValidName"
              )
          
          hr.my-5
          
          // 선택 항목
          div.form-section-title.mb-3 {{$t('join_form.optional_field')}}
          
          // 가입 구분
          div.form-row.align-items-center
            label.form-label.custom-label(for="useFor") {{$t('use_for')}}
            div.col
              b-form-select#useFor(v-model="useFor" :options="useForOptions" class="cursor-pointer")
          
          // 전화번호
          div.form-row.align-items-center
            label.form-label.custom-label(for="phone") {{$t('phone')}}
            div.col
              b-form-input#phone(
                type="text",
                v-model="form.phone",
                :placeholder="$t('phone')",
              )
          
          // 회사 이름
          div.form-row.align-items-center.mb-3
            label.form-label.custom-label(for="company_name") {{$t('company') + ' ' + $t('name')}}
            div.col
              b-form-input#company_name(
                type="text",
                v-model="form.company_name",
                :placeholder="$t('company') + ' ' + $t('name')"
                :disabled="useFor === 'PERSONAL'"
              )
          
          // 회사 홈페이지
          .form-row.align-items-center.mb-3
            label.form-label.custom-label(for="company_website") {{$t('company') + ' ' + $t('homepage')}}
            .col
              b-form-input#company_website(
                type="text",
                v-model="form.company_website",
                :placeholder="$t('company') + ' ' + $t('homepage')"
                :disabled="useFor === 'PERSONAL'"
              )
          
          // 약관 영역
          div.agreement-box.mt-4
            label.custom-checkbox
              input(type="checkbox", v-model="checked.all", @change="check('all', checked.all)")
              span.box
              span.label-text {{$t('agreement.agree_all')}}
            
            label.custom-checkbox
              input(type="checkbox", v-model="checked.use", @change="check('use', checked.use)")
              span.box
              span.label-text
                | ({{$t('required_label')}}) {{$t('agreement.agree_use')}}
                button.view-link(type="button", @click="openModal('use')") {{$t('agreement_view_text')}}
            
            label.custom-checkbox
              input(type="checkbox", v-model="checked.privacy", @change="check('privacy', checked.privacy)")
              span.box
              span.label-text
                | ({{$t('required_label')}}) {{$t('agreement.agree_privacy')}}
                button.view-link(type="button", @click="openModal('privacy')") {{$t('agreement_view_text')}}
          
          // 회원가입 버튼
          div.mt-4.text-center
            b-button.submit-button(
              variant='info'
              size='lg'
              type='submit'
              :disabled='!checked.all || isSubmitting'
            ) {{$t('signup')}}
      
      // 약관 다이얼로그
      dialog-agreement(
        :modal-id='dialog.id'
        :title='dialog.title'
        :content='dialog.content'
      )
      
      // 가입 완료 다이얼로그
      b-modal#signup-success(
        hide-footer
        centered
        :title="$t('signup_done')"
        @hidden="onSignupModalClosed"
      )
        div.text-center.p-4
          h5.font-weight-bold {{$t('check_email_message')}}
          p.mt-2 {{$t('check_email_desc')}}
          p.font-weight-bold.text-info.mt-2 {{ form.mgrid }}
          b-button.w-100.mt-3.py-2.px-5(
            variant='info'
            @click="goToLogin"
            style="border-radius: 8px; font-weight: bold; font-size: 16px;"
          ) {{$t('submit')}}
</template>

<script>
import _ from 'lodash'
import {CheckAPI, ManagersAPI} from '@/api'
import {HeaderWithoutMenu} from '../../mixins/header'
import ToggleBox from '../../mixins/togglebox'
import DialogAgreement from '@/components/dialogs/dialogAgreement.vue'

export default {
  name: 'join-component',
  components: {DialogAgreement, HeaderWithoutMenu, ToggleBox},
  methods: {
    isValidId: _.debounce(function () {
      let id = this.form.mgrid
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      
      if (reg.test(id)) {
        this.validates.mgrid = true
        let params = {
          timestamp: _.now(),
          type: 'email',
          value: id,
        }
        CheckAPI.get('', {params})
            .then(({data}) => {
              this.validates.exist = data.objects.available
              this.form.mail = id
            })
      } else {
        this.validates.mgrid = false
      }
    }),
    isValidPw() {
      const pw = this.form.pw
      const pwRegex = /^(?=\S{8,12}$)(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).*$/
      
      this.validates.pw = pwRegex.test(pw)
    },
    isValidPwConfirm() {
      const pw = this.form.pw
      const pwConfirm = this.form.pwConfirm
      
      this.validates.pwConfirm = this.validates.pw && pw === pwConfirm
    },
    isValidName() {
      this.validates.name = Boolean(this.form.name)
    },
    register() {
      // 중복 방지 코드
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true
      
      const vd = this.validates
      
      const validationMap = [
        [vd.mgrid, 'invalid_id'],
        [vd.exist, 'id_exist'],
        [vd.pw, 'password_requirement'],
        [vd.pwConfirm, 'password_confirm'],
        [vd.name, 'name_requirement'],
      ]
      
      for (const [condition, path] of validationMap) {
        if (!condition) {
          this.AppState.$emit('show-message-dialog', {
            title: 'LinkMeMine',
            context: {path: path}
          })
          this.isSubmitting = false
          return
        }
      }
      
      ManagersAPI.post('', this.form)
          .then(resp => {
            this.$bvModal.show('signup-success')
          })
          .finally(() => {
            this.isSubmitting = false
          })
    },
    check(key, value) {
      if (key === 'all') {
        if (value) {
          this.checked.all = true
          this.checked.use = true
          this.checked.privacy = true
        } else {
          this.checked.all = false
          this.checked.use = false
          this.checked.privacy = false
        }
      } else if (key === 'use') {
        if (value) {
          this.checked.use = true
          if (this.checked.privacy === true) {
            this.checked.all = true
          }
        } else {
          this.checked.use = false
          this.checked.all = false
        }
      } else if (key === 'privacy') {
        if (value) {
          this.checked.privacy = true
          if (this.checked.use === true) {
            this.checked.all = true
          }
        } else {
          this.checked.privacy = false
          this.checked.all = false
        }
      }
    },
    toggleShowPw() {
      this.showPw = !this.showPw
      this.iconName = this.showPw ? 'eye' : 'eye-slash'
    },
    openModal(type) {
      if (type === 'use') {
        this.dialog.title = this.$t('agreement.agree_use')
        this.dialog.content = this.$t('agreement.agree_use_context')
      } else if (type === 'privacy') {
        this.dialog.title = this.$t('agreement.agree_privacy')
        this.dialog.content = this.$t('agreement.agree_privacy_context')
      }
      this.$root.$emit('bv::show::modal', this.dialog.id)
    },
    goToLogin() {
      this.$router.push('/')
    },
    onSignupModalClosed() {
      this.goToLogin()
    },
  },
  watch: {
    'form.pw'() {
      this.isValidPw()
      this.isValidPwConfirm()
    },
  },
  data() {
    return {
      isSubmitting: false,
      showPw: false,
      iconName: 'eye-slash',
      checked: {
        all: false,
        use: false,
        privacy: false,
      },
      form: {
        company_name: null,
        company_website: null,
        lang_code: this.$i18n.locale,
        mgrid: null,
        mail: null,
        name: null,
        phone: null,
        pw: null,
        pwConfirm: null,
        time_zone_id: 32,
      },
      validates: {
        mgrid: false,
        exist: true,
        name: false,
        pw: false,
        pwConfirm: false,
      },
      useFor: 'PERSONAL',
      useForOptions: [
        {value: 'PERSONAL', text: this.$t('personal')},
        {value: 'ENTERPRISE', text: this.$t('enterprise')},
      ],
      dialog: {
        id: 'agreement-modal',
        title: '',
        content: '',
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.form-container {
  margin: 50px auto 0;
  width: 90%;
  max-width: 750px;
  transition: all 500ms;
  
  .logo-image {
    width: 400px;
    height: auto; // 비율 유지
    display: block; // 중앙 정렬 시 유용
    //margin: 0 auto; // 중앙 정렬 (선택)
  }
  
  @media (max-width: 768px) {
    margin-top: 20px;
    .logo-image {
      width: 300px;
    }
  }
}

.custom-label {
  flex: 0 0 16.6667%;
  max-width: 16.6667%;
  margin-bottom: 0;
  
  @media (max-width: 768px) {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }
}

.form-section-title {
  color: #2962ff;
  font-size: 18px;
  font-weight: 700;
  margin: 20px 0 10px;
}

.form-row {
  margin-bottom: 1rem;
  
  > label {
    padding-left: 15px;
    font-size: 15px;
    
    > strong {
      margin-left: 5px;
    }
  }
  
  @media (max-width: 768px) {
    > label {
      font-size: 14px;
    }
    input, select {
      font-size: 12px;
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}

.agreement-box {
  background-color: #eeeeee;
  padding: 20px 13px 20px 50px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 0.75rem;
  cursor: pointer;
  width: fit-content;
  
  .view-link {
    margin-left: 0.5rem;
    color: #2563eb;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    
    .view-link {
      font-size: 12px;
    }
  }
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

/* 체크박스 박스 디자인 */
.custom-checkbox .box {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 6px;
  margin-right: 0.75rem;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s;
}

/* 체크 상태일 때 박스 스타일 변경 */
.custom-checkbox input[type="checkbox"]:checked + .box {
  background-color: #2563eb;
  border-color: #2563eb;
}

/* 체크 마크 스타일 */
.custom-checkbox input[type="checkbox"]:checked + .box::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.fa-style {
  align-items: center;
  
  .fas {
    cursor: pointer;
  }
}

hr {
  border: none;
  border-top: 1px solid #c4c4c4;
  height: 0;
}

.submit-button {
  background-color: #2962ff;
  width: 300px;
  
  &:disabled {
    background-color: #c4c4c4 !important;
    border: 1px solid #d2d2d2;
    cursor: not-allowed;
    color: #666;
  }
  
  @media (max-width: 768px) {
    width: 50%;
  }
}
</style>
